import { useContextSelector } from "use-context-selector";
import { ProductsServerStateContext } from "../Context/ServerState";
import { ProductsServerStateContextType } from "../Context/ServerState/useValues";


export function useGetProductsServerValues<Selected>(fn: (state: ProductsServerStateContextType) => Selected): Selected {
  return useContextSelector(ProductsServerStateContext, fn);
}
